import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import "../styles/gdpr.css";

export default function GDPR() {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("gdpr", lang).then(data => setContent(data));
  }, [lang]);

  const text = [
    content.gdpr_text,
    content.gdpr_text_1,
    content.gdpr_text_2,
    content.gdpr_text_3,
    content.gdpr_text_4,
    content.gdpr_text_5,
    content.gdpr_text_6,
    content.gdpr_text_7,
    content.gdpr_text_8,
    content.gdpr_text_9,
    content.gdpr_text_10,
    content.gdpr_text_11,
    content.gdpr_text_12,
    content.gdpr_text_13,
    content.gdpr_text_14,
    content.gdpr_text_15,
    content.gdpr_text_16,
    content.gdpr_text_17,
    content.gdpr_text_18,
    content.gdpr_text_19,
    content.gdpr_text_20,
    content.gdpr_text_21,
    content.gdpr_text_22,
    content.gdpr_text_23,
    content.gdpr_text_24,
  ].filter(Boolean);

  if (!content) return <p>Loading...</p>;
  return (
  <section className="gdpr-page">
      <h1 className="gdpr-title">{content.gdpr_title}</h1>
      <p>{content.gdpr_subtitle}</p>
      <div className="gdpr-content-list">
        {text.map((item, idx) => (
          <div key={idx} className="gdpr-content-item">
            {item}
          </div>
        ))}
      </div>

      <div className="spacer"/>
    </section>

  );

};